"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._404 = exports.handler = void 0;
const hasStatus = (expected, err) => {
    const actual = err.response ? err.response.status : -1;
    if (typeof expected === 'number') {
        return expected === actual;
    }
    else {
        return expected.includes(actual);
    }
};
exports.handler = (status) => (fallback) => (err) => {
    if (hasStatus(status, err)) {
        return Promise.resolve(fallback);
    }
    return Promise.reject(err);
};
exports._404 = exports.handler(404);
//# sourceMappingURL=handlers.js.map